export var DKTribunalCaseType;
(function (DKTribunalCaseType) {
    DKTribunalCaseType["DKBetalingspaakrav"] = "DK-BETALINGSPAAKRAV";
    DKTribunalCaseType["DKFogedrekvisition"] = "DK-FOGEDREKVISITION";
    DKTribunalCaseType["DKAndreFogedsager"] = "DK-ANDREFOGEDSAGER";
})(DKTribunalCaseType || (DKTribunalCaseType = {}));
//# sourceMappingURL=denmark.js.map